<template lang="pug">
  .unauthorized.simple
    slot(name="header")
    main.flex.justify-center.flex-wrap
      Error.error(
        :code="401"
        message="Du bist aktuell nicht angemeldet.<br>Bitte melde dich an, um diese Seite anzuzeigen."
      )
      //- Authenticate(
      //-   defaultTab="signin"
      //-   :registration="false"
      //- )
</template>

<script>
import Error from '@/components/Error';
import Authenticate from '@/extensions/restricted-area/components/Authenticate';

export default {
  name: 'Unauthorized',
  components: {
    Error,
    Authenticate
  }
};
</script>

<style lang="sass" scoped>
.unauthorized
  display: flex
  flex-direction: column
  flex-grow: 1
.error
  @apply py-6
main
  flex-grow: 1
  flex-direction: column
  margin-bottom: 140px
  ::v-deep
    .title
      @apply text-gray-400
</style>
